<template>
  <div class="seomain">
    <st-header
      title="客户付款"
      :back-able="true"
			:more-op="[{val: 'openShowSearch', title: '搜索' }, { val: 'download', title: '下载对账单' }]"
			@command="headercommand"
    >
      <template slot="header-right">
        <!-- <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span> -->
      </template>
    </st-header>

    <ul class="tab-tilte four">
      <li
        v-for="(item, index) in tabs"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ item.title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
		

    <div class="tab-content tab-content-list">
			
			<!-- 搜索 多行 -->
			<div class="keyword">
			  <van-form @submit="onSearch" v-if="showSearch">
					<st-select
						field-lable="客户"
					  v-model="searchData.clientid"
					  name="客户"
					  placeholder="请选择客户"
					  :options="$option['getCustomer']"
						:clearable="true"
					>
					</st-select>
			    <van-field v-model="searchData.rp_code" label="收款单号" placeholder="请输入收款单号" />
			    <van-field v-model="searchData.order_code" label="订单编号" placeholder="请输入订单编号" />
			    <div :style="{ padding: '16px', backgroundColor: '#fff' }">
			      <van-button round block type="info" native-type="submit">搜 索</van-button>
			    </div>
			  </van-form>
				<div style="text-align: center;background-color: white;">
					<div style="margin: 0px 24px;border-top: 1.5px solid #52596e;">
						<span @click="showSearch = !showSearch" style="color: grey!important;font-size: 18px;font-weight: 900;padding: 0px 160px;">
							<van-icon :name="showSearch ? 'arrow-up' : 'arrow-down'" />
						</span>
					</div>
				</div>
			</div>
      <div class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
				    <div class="st-list-top" style="justify-content: space-between;">
							<div style="position: relative;">
								<div class="t-tit"  style="position: relative;top: 50%;transform: translateY(-50%);">{{ v.code }}</div>
							</div>
				    </div>
				    <div class="st-list-main"
				    	@touchstart="touchstart"
				    	@touchmove="touchmove"
				    	@touchend="touchend"
				    	@click="checkItem(v.id)"
				    >
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
				      <p>收款单号：{{ v.code }}</p>
				      <p>订单编号：{{ v.order_code }}</p>
				      <p>客户经理：{{ v.seller }}</p>
				      <p>提&nbsp;&nbsp;单&nbsp;人：{{ v.orderoperator }}</p>
				      <p>客&emsp;&emsp;户：{{ v.customer }}</p>
				      <p>收款公司：{{ v.corporation }}</p>
				      <p>订单类型：{{ v.order_type_text }}</p>
				      <p>收款方式：{{ v.type_text }}</p>
				      <p>是否逾期：<span style="color: red;" v-if="v.is_expire">已逾期</span> <span v-else>未逾期</span></p>
							
							<p>状&emsp;&emsp;态：{{ v.status_text }}</p>
				      <p>收款金额：{{ v.amount }} {{ v. currency }}</p>
							<p>应收时间：{{ v.predicttime_text }}</p>
							<p>收款时间：{{ v.paymenttime_text }}</p>
				      <p>创建时间：{{ v.createdatetime }}</p>
				    </div>
						<div class="st-list-bottom-2">
							<!-- <div style="flex:1;padding:0px 8px;height:44px;display: none;">
								<div class="st-list-bottom-xs" style="background-color: orange;height: 42px;line-height: 42px;padding:0px;">
									<router-link :to="'/customer/save?id=' + v.id" class="st-opt-btn" style="margin-top: 8px;padding-top:14px;">编辑</router-link>
								</div>
							</div>
							<van-button v-if="v.status == 1"  @click="openApproveDetail(v.id)" type="primary" class="st-opt-btn" style="flex: 1;">审批详情</van-button> -->
							<!-- <van-button v-if="v.status == 0"  @click="approval(v.id)" type="info" class="st-opt-btn" style="flex: 1;">提交申请</van-button> -->
						</div>
				   
				  </div>
				</van-list>
			</div>
      
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[type]"
				@command="batchCommand"
			></batch-btn>
		</div>

  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
import StSelect from "@/components/Select.vue";
export default {
  components: {
    "st-header": StHeader,
		'batch-btn': BatchBtn,
		StSelect,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
			searchData: {},
      page: 1,
			tabs: [
				{ title: '全部', type: '0' },
				{ title: '待收款', type: '1' },
				{ title: '审核中', type: '2' },
				{ title: '已收款', type: '3' },
			],
      cur: 0,
			type: 0,
      show: !1,
			
			mode: this.$route.params.mode,
      oneinfo: {},
      stlist: [],
			
			// 批量操作相关
			checkList: {},
			batchBtnOptions: {},
			touchLong: false,
			showSearch: false,
    };
  },
  watch: {
  	touchLong: function(nv, ov) {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },
  computed: {},
	created() {},
  methods: {
    async get_st_list(e) {
      this.stlist = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("incomeorder_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
				this.type = this.tabs[activeIndex].type;
      }
			
			this.setBatchBtnOption();
    },
    changeActiveIndex(value) {
			this.touchLong = false;
      this.cur = value;
			this.type = this.tabs[value].type;
      window.sessionStorage.setItem("incomeorder_activeIndex", value);
    },
    // 分页
    async onLoad() {
			this.loading = true;
			let type = this.tabs[this.cur]['type'];
			let params = JSON.parse(JSON.stringify(this.searchData));
			params.page = this.page;
			params.tag = type;
      let result = await this.$post(this.$api.stIncomeOrderReconciliation, params);
      if (result.data.rows.length == 0) return (this.finished = true);
      // 进行操作
      this.stlist.push(...result.data.rows);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },

    onSearch() {
			this.touchLong = false;
      this.stlist= [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
		
		// #region-start 批量操作相关方法
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		// 设置 批量操作的按钮
		setBatchBtnOption() {	
			let options = {};
			let oprator = {};
			let option = [
				{ text: '操作', children: [],
				}
			];
			
			for(let tit in this.tabs) {
				let v = this.tabs[tit];
				let children = [];
				if (v.type == 0) {
					children = [];
				}  else if (v.type == 1) {
					children = [];
				} else if (v.type == 2) {
					children = [];
				}
				if (children.length > 0)  options[v.type] = JSON.parse(JSON.stringify(option));
	
				children.forEach((child) => {
					if (options[v.type]) {
						options[v.type][0].children.push(oprator[child]);
					}
					
				})
			}
			
			this.batchBtnOptions = options;
		},
		// 批量处理
		batchCommand(sign, params) {},
		
		// 更多里的操作
		headercommand(val) {
			this[val]();
		},
		// 打开搜索
		openShowSearch() {
			this.showSearch = true;
		},
		
		// 下载
		download() {
			let type = this.tabs[this.cur]['type'];
			let params = JSON.parse(JSON.stringify(this.searchData));
			params.tag = type;
			this.$post(this.$api.stIncomeOrderDownload,params).then((res) => {
				window.location.href = res.data;
			})
		},
		
		// 删除订单
		del(id, api) {
			this.$confirm('您正在进行客户删除操作，是否继续进行？').then((data) => {
				this.$post(api, {ids: id}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('删除成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch((e) => {
				console.log('您取消了删除操作');
			});
		},
		// #region-edn 批量操作相关方法
		
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content-list {
	padding-top: 50px;
}
.st-list-box{
	padding-top: 20px;
	margin: 0px 24px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.keyword {
  position: sticky;
	top:90px;
  width: 100%;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	
	::v-deep .st-select .van-field {
		box-shadow: none!important;
	}
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-2,.st-list-bottom-3 {
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
}

.st-list-bottom-2 {
	.van-button {
		margin-top: 8px;
		width: 45%;
		border-radius: 8px;
	}
}

.st-list-bottom-3 {
	.van-button {
		width: 30%;
		border-radius: 8px;
	}
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
}
.tab-tilte.four .text-center {
  flex: 1;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
</style>
